import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useHistory } from 'react-router'
import { newOrder as newOrderAction } from '@/checkout-instore-legacy/utils/SidebarUtils'
import {
  Divider,
  IconShareNetwork,
  IconShoppingCartSimple,
  csx,
  useToast,
} from '@vtex/admin-ui'

import { DrawerTitle } from '../../../../../../ui/components'
import { OptionItem } from './OptionItem'
import { CartRoute } from '../../constants'
import { TransferCartIcon } from './TransferCartIcon'
import { useOrderForm } from '../../../../../../core/requests/checkout'
import { getSalesAssociateCodeFromOrderForm } from '../../../../../../core/utils/orderForm'
import { List } from '../../../../components'
import { useFeatureFlag, useInitialPath } from '../../../../../../core/hooks'
import { getNewSaleRoute } from '../../../../../../utils/getNewSaleRoute'

export const OptionsContent = () => {
  const history = useHistory()
  const { orderForm } = useOrderForm()
  const initialPath = useInitialPath()
  const showToast = useToast()
  const { formatMessage } = useIntl()
  const { isNewSaleCartRedirectEnabled } = useFeatureFlag()

  const newSaleRoute = getNewSaleRoute(
    initialPath,
    isNewSaleCartRedirectEnabled()
  )

  const salesAssociateCode = getSalesAssociateCodeFromOrderForm(orderForm)
  const handleOptionClick = (route: CartRoute) => () => {
    !salesAssociateCode && route === 'share'
      ? history.push(`${CartRoute.Options}/code?share-cart=true`)
      : history.push(`${CartRoute.Options}/${route}`)
  }

  const handleNewSaleButtonClick = () => {
    if (orderForm?.items.length) {
      showToast({
        message: formatMessage({
          id: 'checkout.toast.new-sale',
        }),
        action: {
          label: formatMessage({
            id: 'checkout.toast.new-sale.go-now',
          }),
          onClick: () => {
            history.push('/orders')
          },
        },
      })
    }

    newOrderAction()
    history.push(newSaleRoute)
  }

  return (
    <>
      <DrawerTitle
        className={csx({
          '@desktop': {
            marginTop: '$space-7',
          },
        })}
      >
        <FormattedMessage id="checkout.options-drawer.title" />
      </DrawerTitle>
      <List className={csx({ marginTop: '$space-3' })}>
        <OptionItem
          icon={<IconShareNetwork />}
          onClick={handleOptionClick(CartRoute.Share)}
        >
          <FormattedMessage id="checkout.options-drawer.share-cart" />
        </OptionItem>
        <Divider />
        <OptionItem
          icon={<TransferCartIcon />}
          onClick={handleOptionClick(CartRoute.TransferOption)}
        >
          <FormattedMessage id="checkout.options-drawer.transfer.title" />
        </OptionItem>
        <Divider />

        <OptionItem
          icon={<IconShoppingCartSimple />}
          onClick={handleNewSaleButtonClick}
        >
          <FormattedMessage id="checkout.options-drawer.start-new-sale" />
        </OptionItem>
      </List>
    </>
  )
}
